import useCrud from 'hooks/useCrud';
import { storeList } from 'services/api/assistant.group';

function readList() {
  return storeList().then((res = []) => res);
}

export function useAvailableStore() {
  return useCrud({
    readList,
  });
}

export default useAvailableStore;
